import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import IconButton from "@material-ui/core/IconButton";
import DeleteIcon from "@material-ui/icons/Delete";

export default ({cartsTotal,removeFromCart}) => {

    return  <>
        {cartsTotal.map(cart => {
            return <List >
                <ListItem>
                    <ListItemAvatar>
                        <Avatar>
                            <img src={cart.productImage} alt="product image"/>
                        </Avatar>
                    </ListItemAvatar>
                    <ListItemText
                        primary={cart.productName}
                    />
                    <ListItemSecondaryAction>
                        <IconButton edge="end" aria-label="delete">
                            <DeleteIcon onClick={() => removeFromCart(cart.id)} />
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>
            </List>
        })}
        </>
}